import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import { completeSightHubSignIn } from './lib/sso'
import './index.css'

// Before the first render: a SightHub sign-in comes back as `#sso_code=…`, which has
// to leave the address bar before the router reads it. AuthProvider then waits on
// this same handoff before it listens for a session.
void completeSightHubSignIn()

const root = document.getElementById('root')
if (!root) throw new Error('#root is missing from index.html')

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
